import {computed, observable, override} from 'mobx';

import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {LiveStreamingModuleConfig} from "../live-streaming-module.config";
import {LIVE_STREAMING_MODULE} from "../live-streaming-widget.consts";
import {BookmakerLogoParams} from "../../../../../domain/common/bookmaker/models/bookmaker-logo-params";
import {BookmakerLogoDarkTransparentRequestParams} from "../../../../../domain/common/bookmaker/models/bookmaker-logo.dark-transparent.request-params";
import {BookmakerLogoTransparentRequestParams} from "../../../../../domain/common/bookmaker/models/bookmaker-logo.transparent.request-params";
import {COMPONENT_STATES} from "../../../../../core/consts";

export class LiveStreamingModuleState extends BaseModuleState {
  @observable stripColorMode: String;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, LiveStreamingModuleConfig];

  @override get isPopulated(): Boolean {
    const isPopulated: Boolean = this.componentState === COMPONENT_STATES.loading || this.dataSource?.game?.liveStreaming?.length > 0

    return isPopulated;
  }

  @computed get bookmakerId(): Number {
    return this.dataSource?.game?.liveStreaming?.first().bookmakerId;
  }

  @computed get bookmakerName(): Number {
    return this.dataSource?.bookmakers?.first(bookie => bookie.id === this.bookmakerId)?.name;
  }

  @computed get bookmakerLink(): String {
    const bookmakerLink: String = this.dataSource?.game?.liveStreaming?.first()?.links?.first();

    return bookmakerLink;
  }

  @computed get bookmakerLogo(): BookmakerLogoParams {
    const width: Number = this.device.isSmallView ? LIVE_STREAMING_MODULE.LOGO.MOBILE_SIZES.width : LIVE_STREAMING_MODULE.LOGO.DESKTOP_SIZES.width;
    const height: Number = this.device.isSmallView ? LIVE_STREAMING_MODULE.LOGO.MOBILE_SIZES.height : LIVE_STREAMING_MODULE.LOGO.DESKTOP_SIZES.height;

    const lightModeLogo: BookmakerLogoParams = new BookmakerLogoDarkTransparentRequestParams({width, height}, {id: this.bookmakerId});
    const darkModeLogo: BookmakerLogoParams = new BookmakerLogoTransparentRequestParams({width, height}, {id: this.bookmakerId});

    const bookmakerLogo: BookmakerLogoParams = this.isDarkMode ? darkModeLogo : lightModeLogo;

    return bookmakerLogo;
  }

  @computed get watchLiveSpan(): String {
    const className: String = `'${['live-streaming-module-highlight-text', this.device.isSmallView ? 'live-streaming-module-small-view' : ''].join(' ')}'`
    const watchLiveSpan: String = ` ${this.terms.WEB_WATCH_LIVE_STREAMING.addClassToSubString(className)} `;

    return watchLiveSpan;
  }

  @computed get gameId(): Number {
    const gameId: Number = this.dataSource?.game.id

    return gameId
  }

  @computed get sportTypeId(): Number {
    const sportTypeId: Number = this.dataSource?.game.sport.id

    return sportTypeId
  }

  @computed get statusGroup(): String {
    const statusGroup: String = this.dataSource?.game.statusGroup

    return statusGroup
  }

  @computed get isDarkMode(): Boolean {
    const isDarkMode: Boolean = this.appState.isDarkMode;

    return isDarkMode
  }
}
